import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles(() => ({
    PageWrap: {
        background: "#ffffff",
        display: "flex",
        justifyContent: "center",
        overflow: "hidden",
    },
    NewTablesPage: {
        // width: '1024px',
        width: "100vw",
        height: "100vh",
    },
    NewOrderPage: {
        // width: "1024px",
        width: "100vw",
        minHeight: "100vh",
        background: "#f5f6fa",
        padding: "20px 0",
        display: "flex",
        margin: "auto",
    },
    Header: {
        background: "#ffffff",
        borderBottom: "1px solid #e5e9f2",
        display: "flex",
        alignItems: "center",
        "& .Logo": {
            padding: "5px",
            marginRight: "1rem",
            marginLeft: "0.4rem",
            // position: "fixed",
            zIndex: 9999,
            "& img": {
                width: "118px",
            },
        },
        "& .NameLocation": {
            marginRight: "5rem",
            "& div:first-child": {
                fontStyle: "normal",
                fontWeight: "700",
                fontSize: "14px",
                lineHeight: "17px",
                textTransform: "uppercase",
                color: "#271D1C",
            },
            "& div:last-child": {
                fontStyle: "normal",
                fontWeight: "700",
                fontSize: "10px",
                lineHeight: "12px",
                textTransform: "uppercase",
                color: "rgba(39, 29, 28, 0.75)",
            },
        },

        "& .SettingsIcon": {
            marginLeft: "auto",
            display: "flex",
            "& .UserLink": {
                display: "flex",
            },
        },
        "& .Actions": {
            display: "flex",
            alignItems: "center",
            paddingRight: "32px",
            "& div": {
                background: "#FFFFFF",
                border: "0px solid #6E7187",
                fontStyle: "normal",
                fontWeight: "700",
                fontSize: "10px",
                lineHeight: "15px",
                textAlign: "center",
                textTransform: "uppercase",
                color: "#6E7187",
                padding: "10px 20px",
                cursor: "pointer",
            },
        },
        buttonGroup: {
            "& button": {
                background: "#FFFFFF",
                border: "0px solid #6E7187",
                fontStyle: "normal",
                fontWeight: "700",
                fontSize: "1px",
                lineHeight: "15px",
                textAlign: "center",
                textTransform: "uppercase",
                color: "#6E7187",
                padding: "14px 24px",
            },
        },
    },
    BtnSave: {
        background: "#6E7187",
        boxShadow:
            "0px 10px 30px rgba(0, 0, 0, 0.07), 0px 4px 18px rgba(249, 98, 83, 0.25)",
        borderRadius: "8px",
        fontStyle: "normal",
        fontWeight: "700",
        fontSize: "12px",
        lineHeight: "15px",
        textAlign: "center",
        textTransform: "uppercase",
        color: "#FFFFFF",
        padding: "16px",
        // "width": "318px",
        // "height": "47px",
        border: "none",
    },
    Body: {
        display: "flex",
        overflow: "hidden",
    },
    Body__Sidebar: {
        background: "#f5f6fa",
        display: "flex",
        flexDirection: "column",
        "& .OnTable": {
            background: "#6E7187",
            fontStyle: "normal",
            fontWeight: "700",
            fontSize: "12px",
            lineHeight: "15px",
            textAlign: "center",
            textTransform: "uppercase",
            color: "#FFFFFF",
            padding: "14px 0",
            cursor: "pointer",
        },
    },
    Body__TableView: {
        background: "#f5f6fa",
        flex: 1,
        display: "flex",
        // padding: '0px 0px 0',
        "& .TablesWrap": {
            // width: '844px',
            margin: "0 auto",
            position: "relative",
            "& .Table_": {
                // width: "60px",
                // height: "60px",
                color: "#fff",
                background: "#e14954",
                // borderRadius: '50%',
                position: "absolute",
                textAlign: "center",
                // "transform": "translate(-50%, -50%)",
                lineHeight: "30px",
                cursor: "pointer",
                border: "none",
                padding: 0,
            },
            "& .Table_Printed": {
                width: "60px",
                height: "60px",
                color: "#fff",
                background: "#c5c52e",
                position: "absolute",
                textAlign: "center",
                lineHeight: "30px",
                cursor: "pointer",
                border: "none",
                padding: 0,
            },
            "& .Table_Reserved": {
                width: "60px",
                height: "60px",
                color: "#fff",
                background: "#B12AE0",
                // borderRadius: '50%',
                position: "absolute",
                textAlign: "center",
                lineHeight: "30px",
                cursor: "pointer",
                border: "none",
                padding: 0,
            },
            "& .SelectableTable": {
                width: "100px",
                height: "100px",
                // color: '#fff',
                // background: '#1595B5',
                // borderRadius: '50%',
                // border: '2px solid #fff',
                // zIndex: 999,
                // // position: 'absolute',
                // textAlign: 'center',
                // // lineHeight: '30px',
                // cursor: 'pointer',
                // // border: 'none',
                // padding: 0
            },
            "& .Table_Empty": {
                width: "60px",
                height: "60px",
                color: "#fff",
                background: "gray",
                // borderRadius: '50%',
                position: "absolute",
                textAlign: "center",
                lineHeight: "30px",
                cursor: "pointer",
                border: "none",
                padding: 0,
            },
        },
    },
    Body__TableViewContainer: {
        background: "#e5e9f2",
        width: "100%",
        height: "400px",
    },
    RoomPicker: {
        marginLeft: "120px",
        padding: "1rem 0",
    },
}));
